const FLAG_VIEWBOX = '0 0 20 14';

// Nordic cross geometry shared by DK, NO, SE and FI style flags.
const nordicCross = (color, width) =>
  `<path d="M7.5 0v14M0 7h20" stroke="${color}" stroke-width="${width}" fill="none"/>`;

const FLAG_SVG = {
  GB:
    '<rect width="20" height="14" fill="#012169"/>' +
    '<path d="M0 0l20 14M20 0L0 14" stroke="#fff" stroke-width="2.8"/>' +
    '<path d="M0 0l20 14M20 0L0 14" stroke="#C8102E" stroke-width="1.4"/>' +
    '<path d="M10 0v14M0 7h20" stroke="#fff" stroke-width="4.6"/>' +
    '<path d="M10 0v14M0 7h20" stroke="#C8102E" stroke-width="2.6"/>',

  IE:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="6.67" height="14" fill="#169B62"/>' +
    '<rect x="13.33" width="6.67" height="14" fill="#FF883E"/>',

  AT:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="20" height="4.67" fill="#ED2939"/>' +
    '<rect y="9.33" width="20" height="4.67" fill="#ED2939"/>',

  BE:
    '<rect width="20" height="14" fill="#FAE042"/>' +
    '<rect width="6.67" height="14" fill="#000"/>' +
    '<rect x="13.33" width="6.67" height="14" fill="#ED2939"/>',

  DK: '<rect width="20" height="14" fill="#C8102E"/>' + nordicCross('#fff', 3),

  FR:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="6.67" height="14" fill="#002395"/>' +
    '<rect x="13.33" width="6.67" height="14" fill="#ED2939"/>',

  DE:
    '<rect width="20" height="14" fill="#000"/>' +
    '<rect y="4.67" width="20" height="4.67" fill="#DD0000"/>' +
    '<rect y="9.33" width="20" height="4.67" fill="#FFCE00"/>',

  IT:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="6.67" height="14" fill="#009246"/>' +
    '<rect x="13.33" width="6.67" height="14" fill="#CE2B37"/>',

  LU:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="20" height="4.67" fill="#ED2939"/>' +
    '<rect y="9.33" width="20" height="4.67" fill="#00A1DE"/>',

  NL:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect width="20" height="4.67" fill="#AE1C28"/>' +
    '<rect y="9.33" width="20" height="4.67" fill="#21468B"/>',

  NO:
    '<rect width="20" height="14" fill="#BA0C2F"/>' +
    nordicCross('#fff', 4) +
    nordicCross('#00205B', 2),

  PL:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<rect y="7" width="20" height="7" fill="#DC143C"/>',

  PT:
    '<rect width="20" height="14" fill="#DA291C"/>' +
    '<rect width="8" height="14" fill="#046A38"/>' +
    '<circle cx="8" cy="7" r="2.6" fill="#FFE900"/>' +
    '<circle cx="8" cy="7" r="1.5" fill="#DA291C"/>',

  ES:
    '<rect width="20" height="14" fill="#AA151B"/>' +
    '<rect y="3.5" width="20" height="7" fill="#F1BF00"/>',

  SE: '<rect width="20" height="14" fill="#006AA7"/>' + nordicCross('#FECC00', 3),

  CH:
    '<rect width="20" height="14" fill="#D52B1E"/>' +
    '<path d="M10 3.5v7M6.5 7h7" stroke="#fff" stroke-width="2.2" fill="none"/>',

  US:
    '<rect width="20" height="14" fill="#fff"/>' +
    '<path d="M0 1.08h20M0 3.23h20M0 5.38h20M0 7.54h20M0 9.69h20M0 11.85h20" ' +
    'stroke="#B31942" stroke-width="1.08" fill="none"/>' +
    '<rect width="8.6" height="7.54" fill="#0A3161"/>' +
    '<path d="M1.6 1.6h.1M4 1.6h.1M6.4 1.6h.1M2.8 3.1h.1M5.2 3.1h.1M1.6 4.6h.1M4 4.6h.1M6.4 4.6h.1M2.8 6.1h.1M5.2 6.1h.1" ' +
    'stroke="#fff" stroke-width="1.1" stroke-linecap="round"/>',
};

/** Inner SVG markup for a country, or "" when we have no artwork. */
function countryFlagSvg(code) {
  return FLAG_SVG[code] || '';
}

export { FLAG_VIEWBOX, countryFlagSvg };
